import { useDate } from "~/modules/shared/composables/useDate";

export const useEventCalendarDate = (date: string) => {
  return useDate(date, "YYYYMMDDTHHmmssZ");
};
